import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PackageType } from "@/hooks/usePackageType";
import { useTranslations } from "next-intl";

function PackageTypeToggle({
  packageType,
  setPackageType,
  setCartQuantity,
  handleClearFilter,
  onSwitchToDataVoice,
}: {
  packageType: PackageType;
  setPackageType: React.Dispatch<React.SetStateAction<PackageType>>;
  setCartQuantity: React.Dispatch<React.SetStateAction<number>>;
  handleClearFilter: () => void;
  onSwitchToDataVoice?: () => void;
}) {
  const t = useTranslations();
  const toggleOptions = [
    {
      label: t("Shared.countryPackages.packageTypeToggle.dataOnly"),
      shortLabel: t("Shared.countryPackages.packageTypeToggle.dataOnlyShort"),
      value: "data-only",
    },
    {
      label: t("Shared.countryPackages.packageTypeToggle.dataVoice"),
      shortLabel: t("Shared.countryPackages.packageTypeToggle.dataVoiceShort"),
      value: "data-voice",
    },
  ];

  function handlePackageTypeChange(type: string) {
    setPackageType(type as PackageType);
    setCartQuantity(1);
    handleClearFilter();
    if (type === "data-voice") {
      onSwitchToDataVoice?.();
    }
  }
  return (
    <Tabs
      className="flex min-w-0 w-full items-center gap-2 text-body-sm font-500 sm:gap-3 md:w-auto"
      value={packageType}
      onValueChange={handlePackageTypeChange}
    >
      <TabsList className="grid h-10 w-full min-w-0 grid-cols-2 bg-muted p-0 md:h-auto md:w-auto md:grid-cols-[190px_190px]">
        {toggleOptions.map((opt) => (
          <TabsTrigger
            aria-label={opt.label}
            value={opt.value}
            key={opt.value}
            className="h-full min-w-0 w-full truncate px-1.5 py-0 text-xs text-muted-foreground shadow-none data-[state=active]:border data-[state=active]:border-primary data-[state=active]:bg-card data-[state=active]:text-foreground sm:px-3 sm:text-sm md:!py-2.5"
          >
            <span className="truncate sm:hidden">{opt.shortLabel}</span>
            <span className="hidden truncate sm:inline">{opt.label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
      {/* Here we are using tabcontent just for the accessibility purpose to increase the accessibility score (ARIA issues) */}
      {toggleOptions.map((opt) => (
        <TabsContent
          key={opt.value}
          value={opt.value}
          forceMount
          className="hidden"
        />
      ))}
    </Tabs>
  );
}

export default PackageTypeToggle;
